import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePartnerStatus } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const useUpdatePartnerStatusMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: async ({ partnerProfileId, status, amount }) => {
      const result = await updatePartnerStatus({ partnerProfileId, status, amount });
      if (!result.success) {
        throw new Error(result.message || 'Failed to update partner status');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      await options.onSuccess?.(...args);
    },
  });
};
